import { createAsyncThunk } from "@reduxjs/toolkit";
import { CommissionableServicesService } from "../../services";
import { BaseService } from "../../services/base.service";
import {
  createCRUDThunks,
  handleAsyncThunkError,
} from "../../shared/helpers/thunks.helpers";
import {
  CommissionableServiceFormValues,
  CommissionableServiceRequest,
  CommissionableServiceResponse,
} from "../../shared/types/commissionable-service.types";
import { AxiosParams } from "../../shared/types";

const service = new CommissionableServicesService();

const basicThunks = createCRUDThunks<
  CommissionableServiceRequest,
  CommissionableServiceResponse,
  CommissionableServiceFormValues
>({
  service: service as unknown as BaseService<
    CommissionableServiceRequest,
    CommissionableServiceResponse,
    CommissionableServiceFormValues
  >,
  resourceName: "commissionable-services",
});

const getCommissionCalculation = createAsyncThunk(
  `commissionable-services/getCommissionCalculation`,
  async ({ params }: { params?: AxiosParams }, { rejectWithValue }) => {
    try {
      const responseData = await service.getCommissionCalculation(params);
      const data = responseData.data;
      const sortedData = data.services.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      return { ...data, services: sortedData };
    } catch (error) {
      return handleAsyncThunkError(error, rejectWithValue);
    }
  }
);

export const CommissionableServicesThunks = {
  ...basicThunks,
  getCommissionCalculation,
};
